import * as z from 'zod';
export const StoredGuessSchema = z.object({
    participantId: z.uuidv7(),
    name: z.string(),
});
//# sourceMappingURL=guess.js.map